import React from "react";
import CharacterLimit from "./FormCharacterLimit";
import util from "../../../../global/utils/Helpers";
import PageInfo from "../../UI/PageInfo";

const style = {
  width: "100%",
  resize: "none",
  padding: ".5rem",
};

const TextArea = ({ input, meta, schemaProps, disabled, ...rest }) => (
  <div>
    <textarea
      {...input}
      id={input.name}
      onChange={(e) => {
        e.target.value = util.removeBadChars(e.target.value).trimStart();
        let textVal = e.target.value;
        const byteLength = new Blob([textVal]).size;
        if (byteLength > schemaProps.inputLimit) {
          const diff = byteLength - schemaProps.inputLimit;
          e.target.value = textVal.slice(0, -diff);
        }
        input.onChange(e);
      }}
      style={style}
      autoComplete={"off"}
      rows={schemaProps.rows}
      disabled={disabled || false}
    />
    <CharacterLimit
      length={input && input.value ? new Blob([input.value]).size : 0}
      limit={schemaProps.inputLimit}
    />
    {schemaProps?.info && schemaProps?.info?.position === undefined && (
      <PageInfo {...schemaProps?.info} />
    )}
  </div>
);

export default TextArea;
